<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2y"><a id="page_x"></a><a id="page_xi"></a>CONTENTS</h2>
<p class="tocx"><a href="#/xhtml/ack#ack"><em>Acknowledgments</em></a></p>
<p class="toc1"><a href="#/xhtml/part01#part1"><strong>I. DIZZIED</strong></a></p>
<p class="toc"><a href="#/xhtml/ch01#ch1">Goodbye, Tuscaloosa</a></p>
<p class="toc"><a href="#/xhtml/ch02#ch2">A Test of the Emergency Alert System</a></p>
<p class="toc"><span href="#/xhtml/ch03#ch3" title="Link target outside of Sample">Epistle to an Embryo</span></p>
<p class="toc"><span href="#/xhtml/ch04#ch4" title="Link target outside of Sample">To the Good People of Joplin</span></p>
<p class="toc"><span href="#/xhtml/ch05#ch5" title="Link target outside of Sample">Fifty Ways of Looking at Tornadoes</span></p>
<p class="toc"><span href="#/xhtml/ch06#ch6" title="Link target outside of Sample">The Longest Wait</span></p>
<p class="toc2"><span href="#/xhtml/part02#part2" title="Link target outside of Sample"><strong>II. DROWNED</strong></span></p>
<p class="toc"><span href="#/xhtml/ch07#ch7" title="Link target outside of Sample">The Girl in the Surf</span></p>
<p class="toc"><span href="#/xhtml/ch08#ch8" title="Link target outside of Sample">Dispatches from the Drownings</span></p>
<p class="toc"><span href="#/xhtml/ch09#ch9" title="Link target outside of Sample">Buckethead</span></p>
<p class="toc"><span href="#/xhtml/ch10#ch10" title="Link target outside of Sample">The Changing</span></p>
<p class="toc"><span href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Death by Refrigerator</span></p>
<p class="toc3"><span href="#/xhtml/part03#part3" title="Link target outside of Sample"><strong>III. DROPPED</strong></span></p>
<p class="toc"><span href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Fabricating Fear</span></p>
<p class="toc"><span href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Fort Wayne Is Still Seventh on Hitler’s List</span></p>
<p class="toc"><span href="#/xhtml/ch14#ch14" title="Link target outside of Sample">The Year of the Great Forgetting</span></p>
<p class="toc"><span href="#/xhtml/ch15#ch15" title="Link target outside of Sample">Hirofukushima</span></p>
<p class="toc"><span href="#/xhtml/ch16#ch16" title="Link target outside of Sample">Punch Line</span></p>
<p class="toc"><span href="#/xhtml/ch17#ch17" title="Link target outside of Sample">Bedtime Story</span></p>
<p class="toct"><span href="#/xhtml/work#con" title="Link target outside of Sample"><em>Works Consulted</em></span></p>
<p class="toc"><span href="#/xhtml/credit#cre" title="Link target outside of Sample"><em>Credits</em></span></p>
<p class="toc"><span href="#/xhtml/book#gui" title="Link target outside of Sample"><em>Book Club Guide</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?749daeee